<template>
    <ElTree
        ref="tree"
        :current-node-key="selected"
        :props="{ label: 'name', isLeaf: 'leaf' }"
        :data="data"
        class="login-org-tree"
        default-expand-all
        highlight-current
        node-key="id"
        @node-click="handleClick"
    />
</template>

<script>
    import { ElTree } from 'element-plus';

    export default {
        name: 'SearchTree',
        components: {
            ElTree,
        },
        props: {
            data: {
                type: Array,
                required: true,
            },
            selected: {
                type: Number,
                required: true,
            },
        },
        emits: ['click'],
        methods: {
            handleClick() {
                this.$emit('click', {
                    id: this.$refs.tree.getCurrentKey(),
                    name: this.$refs.tree.getCurrentNode().name,
                });
            },
        },
    };
</script>
